<template>
  <!-- prettier-ignore -->
  <div class="news-container">
    <!-- 搜索与筛选 -->
    <div class="news-toolbar">
      <div class="toolbar-left"></div>
      <div class="toolbar-right">
        <el-input
          v-model="keyword"
          placeholder="请输入资讯关键词"
          clearable
          size="small"
          class="search-input"
          @keyup.enter.native="handleSearch"
          @clear="handleSearch"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleSearch"
          ></el-button>
        </el-input>
        <el-select
          v-model="filterType"
          size="small"
          class="filter-select"
          @change="handleFilterChange"
        >
          <el-option
            v-for="item in filterOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
    </div>

    <!-- 学科分类 -->
    <!-- <div class="subject_wapper">
      <span>资讯分类</span>
      <div class="subject_list">
        <div class="subject-item" @click="handChangeType(index)" :class="{ 'is-active': TypeIndex == index }" v-for="(item, index) in typelist" :key="index">
          {{ item.name }}
        </div>
      </div>
    </div> -->
    <!-- 资讯列表 -->
    <div class="news_wapper">
      <subject-list-skeleton v-if="loading" variant="news" />
      <ul class="news_list" v-if="list.length > 0 && !loading">
        <li v-for="(item, index) in list" :key="index">
          <p class="title" @click="toDetail(item)">
            <span class="news-index">{{ (pageNo - 1) * pageSize + index + 1 }}</span>
            <span class="title-text line1" v-safe-html="item.title" :title="item.title"></span>
            <label :class="getColor(item.type)" v-safe-html="gettext(item.type)"></label>
            <i
              v-if="info && !info.ipUser"
              class="collect-icon el-icon-star-on"
              :class="{ checked: item.share }"
              @click.stop="toCollect(item)"
            ></i>
            <span class="news-date">{{ item.infoDate }}</span>
          </p>
        </li>
      </ul>
    </div>

    <div class="noData" v-if="total == 0 && !loading"><el-empty description="暂无数据"></el-empty></div>
    <el-pagination v-if="!loading" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total" hide-on-single-page> </el-pagination>
  </div>
</template>

<script>
import { EventBus } from "../../utils/eventBus";
import { newColor } from "../../assets/js/oacolor";
import SubjectListSkeleton from "@/components/SubjectListSkeleton.vue";
export default {
  components: { SubjectListSkeleton },
  data() {
    return {
      loading: true,
      moreFlag: false,
      pageNo: 1,
      pageSize: 10,
      subjectCode: "",
      total: -1,
      list: [],
      typelist: [
        {
          type: "10",
          name: "新闻",
        },
        {
          type: "20",
          name: "深入了解",
        },
        {
          type: "30",
          name: "特征",
        },
        {
          type: "40",
          name: "评论",
        },
        {
          type: "50",
          name: "政策论坛",
        },
        {
          type: "60",
          name: "研究亮点",
        },
        {
          type: "70",
          name: "世界观",
        },
        {
          type: "80",
          name: "最新文章",
        },
      ],
      infoType: 10,
      TypeIndex: 0,
      info: {},
      subjectId: "",
      // 搜索与筛选
      keyword: "",
      filterType: "all",
      filterOptions: [
        { label: "全部", value: "all" },
        { label: "新闻", value: 10 },
        { label: "文章", value: 80 },
        { label: "资讯", value: 90 },
      ],
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      // 检查是否已通过EventBus加载数据
      if (sessionStorage.getItem("subjectNodes")) {
        let id = JSON.parse(sessionStorage.getItem("subjectNodes")).id;
        this.getSubjectId(id);
      }
    }, 300);

    EventBus.$on("submitSubject", id => {
      // 标记数据已加载
      this.getSubjectId(id);
    });
  },
  beforeDestroy() {
    // 组件销毁前移除事件监听，避免重复注册
    EventBus.$off("submitSubject");
  },
  methods: {
    getColor(item) {
      return newColor(item);
    },
    gettext(item) {
      switch (item) {
        case 10:
          return "新闻";
        case 20:
          return "深入了解";
        case 30:
          return "特征";
        case 40:
          return "评论";
        case 50:
          return "政策论坛";
        case 60:
          return "研究亮点";
        case 70:
          return "世界观";
        case 80:
          return "最新文章";
        case 90:
          return "资讯";
        default:
          return "";
      }
    },
    getSubjectId(id) {
      window.clearInterval(this.timer);
      this.subjectId = id;
      this.pageNo = 1;
      this.getInfo();
      this.getList();
    },
    getInfo() {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        this.info = res.data;
      });
    },
    getList() {
      this.loading = true;
      let postBody = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        keyWords: this.keyword,
      };
      const subjectNodes = sessionStorage.getItem("subjectNodes") ? JSON.parse(sessionStorage.getItem("subjectNodes")) : null;
      if (subjectNodes && subjectNodes.id != null) {
        postBody.firstSubjectId = subjectNodes.parentId != null ? subjectNodes.parentId : subjectNodes.id;
        postBody.secondSubjectId = subjectNodes.parentId != null ? subjectNodes.id : null;
      }
      if (this.filterType !== "all") {
        postBody.type = this.filterType;
      }
      this.$http({
        url: "/api/v1/discipline/list",
        method: "post",
        data: postBody,
      }).then(res => {
        setTimeout(() => {
          this.loading = false;
        }, 0);
        this.list = res.rows;
        this.total = res.total;
      });
    },
    handleSearch() {
      this.pageNo = 1;
      this.getList();
    },
    handleFilterChange() {
      this.pageNo = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getList();
    },
    // 收藏
    toCollect(item) {
      this.$http({
        url: "api/v1/discipline/share?infoSid=" + item.sid,
        method: "GET",
      }).then(res => {
        if (!item.share) {
          this.$message.success("收藏成功");
        }
        this.getList();
      });
    },
    handChangeType(index) {
      this.TypeIndex = index;
      this.infoType = this.typelist[index].type;
      this.pageNo = 1;
      this.getList();
    },
    toDetail(item) {
      const urlRegex = /^https?:\/\//i;
      if (item.type == 90) {
        if (urlRegex.test(item.originUrl)) {
          window.open(item.originUrl, "_blank");
        } else {
          this.$message.error("无法访问");
        }
        return;
      }
      this.$http({
        url: "api/v1/discipline/link?sid=" + item.sid,
        method: "GET",
      }).then(res => {
        if (urlRegex.test(res.data)) {
          window.open(res.data, "_blank");
        } else {
          this.$message.error("无法访问");
        }
      });
      //  this.$router.push({ path: "/infoDetail", query: { sid: sid } });
    },
  },
};
</script>

<style lang="scss" scoped>
.news-container {
  width: calc(100% - 40px);
  max-width: 1300px;
  min-width: 0;
  margin: 20px auto;
  background: #fff;
  box-sizing: border-box;
  .news-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    .toolbar-left {
      flex: 1;
    }
    .toolbar-right {
      display: flex;
      align-items: center;
      gap: 8px;
      width: min(100%, 648px);
      .search-input {
        flex: 1 1 320px;
        width: auto;
        min-width: 0;
      }
      .filter-select {
        flex: 0 0 100px;
        width: 100px;
      }
    }
  }
  .subject_wapper {
    padding: 20px 20px 10px 20px;
    display: flex;
    line-height: 30px;
    color: #636870;
    font-size: 15px;
    align-items: baseline;
    .subject_list {
      flex: 1;
      column-gap: 8px;
      transition: all 0.3s;
      margin-left: 20px;
      display: flex;
      flex-wrap: wrap;
      .subject-item {
        height: 30px;
        margin-bottom: 10px;
        padding: 6px 10px;
        font-weight: 400;
        font-size: 15px;
        line-height: 20px;
        background-color: #fff;
        border-radius: 4px;
        cursor: pointer;
        color: #333;
        &:hover {
          color: #2c5f97;
        }
      }
      .is-active {
        background: #f2f3f5;
        font-weight: bold;
        color: #2c5f97;
      }
    }
    .more {
      margin-left: 30px;
      cursor: pointer;
      display: flex;
      align-items: center;
      color: #636870;
      i {
        margin-left: 3px;
        font-size: 16px;
        vertical-align: -1px;
      }
    }
  }
  .news_wapper {
    padding: 20px;
    border-top: 10px solid #f7f7f7;
  }
  .news_list {
    font-size: 15px;
    li {
      border-bottom: 1px dashed #eee;
      padding: 20px 0;
      &:nth-of-type(1) {
        padding-top: 0;
      }
      &:last-of-type {
        border: none;
        padding-bottom: 0;
      }
      .title {
        display: flex;
        align-items: center;
        min-width: 0;
        font-weight: 400;
        font-size: 15px;
        color: #333;
        cursor: pointer;
        .news-index {
            margin-right: 8px;
            color: #333;
          font-size: 15px;
          font-weight: 400;
          flex-shrink: 0;
        }
        .title-text {
          flex: 0 1 auto;
          min-width: 0;
          &:hover {
            background-image: linear-gradient(to right, #006eb3, #63ace5);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }

        img {
          margin-right: 10px;
          flex-shrink: 0;
        }
        label {
          font-size: 12px;
          color: #fff;
          margin-left: 8px;
          border-radius: 2px;
          padding: 1px 6px;
          // min-width: 68px;
          font-weight: 400;
          flex-shrink: 0;
          &:hover {
            color: #fff;
          }
        }
        .collect-icon {
          margin-left: 8px;
          color: #c5ccd6;
          font-size: 18px;
          line-height: 1;
          font-weight: 400;
          cursor: pointer;
          transition: color 0.2s;
          flex-shrink: 0;
          &:hover,
          &.checked {
            color: #f5a623;
          }
        }
        .news-date {
          margin-left: auto;
          padding-left: 20px;
          color: #999;
          font-size: 12px;
          font-weight: 400;
          white-space: nowrap;
          flex-shrink: 0;
        }
      }
      .news-ai {
        background: #f7f8fa;
        padding: 20px;
        margin-top: 15px;
        img {
          width: 80px;
        }
        .news-ai-text {
          color: #636870;
          line-height: 25px;
          .digestLabel {
            color: #2c5f97;
            cursor: pointer;
            margin-left: 3px;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .news-container {
    width: calc(100% - 24px);
    margin: 12px auto;

    .news-toolbar {
      padding: 12px;

      .toolbar-left {
        display: none;
      }

      .toolbar-right {
        width: 100%;
        flex-wrap: wrap;

        .search-input {
          flex-basis: 100%;
        }

        .filter-select {
          flex-basis: 100%;
          width: 100%;
        }
      }
    }

    .news_wapper {
      padding: 16px 12px;
    }

    .news_list li .title {
      align-items: flex-start;
      flex-wrap: wrap;
      row-gap: 8px;

      .title-text {
        flex: 1 1 calc(100% - 32px);
      }

      .news-date {
        width: 100%;
        margin-left: 0;
        padding-left: 24px;
      }
    }
  }

  ::v-deep .el-pagination {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    row-gap: 8px;
    padding: 0 12px 16px;
    white-space: normal;
  }
}

::v-deep .el-pager li.active,
::v-deep .el-pager li:hover,
::v-deep .el-select .el-input.is-focus .el-input__inner,
::v-deep .el-pagination__sizes .el-input .el-input__inner:hover {
  color: #63ace5;
  border-color: #63ace5;
}
::v-deep .el-pager li:hover {
  color: #63ace5;
}
::v-deep .el-pagination button:hover {
  color: #63ace5;
}
::v-deep .el-pagination__jump .el-input__inner:focus {
  border-color: #63ace5;
}
</style>
